<div class="container my-3">
  <div class="row mt-4">
    <div class="col-md-7">
      <div class="d-flex justify-content-between align-items-center">
        <h1 class="m-0 mb-3 text">Friends</h1>
        <select class="form-select w-50" style="height: 40px" (change)="onChange($event)">
          @for(games of devices; track $index){
          <option>{{ games }}</option>
          }
        </select>
      </div>
      <div class="friend-input-box">
        <div class="search-container">
          <input type="text" class="search-bar" [(ngModel)]="friendDetails" (ngModelChange)="findData(friendDetails)"
            placeholder="search by Username or PlayerID" />

        </div>

        <main class="mt-3">
          <div class="my-3 mx-3">
            <h1 class="mb-0">Friends</h1>
          </div>
          @if(findFriendData?.length > 0){
          @for (friend of findFriendData; track
          $index) {
          <div id="friends-request" class="my-2">
            <div class="profiles-pictures">
              <div style="position: relative; display: inline-block;" class="me-3">
                <img class="profile-picture m-0" [src]="friend?.image || '/assets/customer-image/men-shadow.png'"
                  alt="profile picture" />
                @if(friend.online){
                <div class="green_dot"></div>
                }
              </div>
            </div>

            <div class="profile-info">
              <div class="profile-name">
                <h2 class="mb-0 btn-hover" (click)="profilememberDetails(friend?.username)">
                  {{ friend.username }}
                </h2>
                <p class="mb-0 fullName">
                  {{ friend.firstname }} {{ friend.lastname }}
                </p>
              </div>
            </div>

            <div class="buttons">
              <button class="confirm" (click)="removeCofirm(friend, $index)">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
          } }@else{
          <p class="p-3 text mb-0">No friends found.</p>
          }
        </main>

        @if(findplayer?.length > 0){
        <main class="mt-3">
          <div class="my-3 mx-3">
            <h1 class="mb-0">suggestion</h1>
          </div>
          @for (friend of findplayer; track $index) {
          <div id="friends-request" class="mb-2">
            <div class="profiles-pictures">
              <div style="position: relative; display: inline-block;" class="me-3">
                <img class="profile-picture m-0" [src]="friend?.image || '/assets/customer-image/men-shadow.png'"
                  alt="profile picture" />
                @if(friend.online){
                <div class="green_dot"></div>
                }
              </div>
            </div>

            <div class="profile-info">
              <div class="profile-name">
                <h2 class="mb-0 btn-hover" (click)="profilememberDetails(friend?.username)">
                  {{ friend.username }}
                </h2>
                <p class="mb-0 fullName">
                  {{ friend.firstname }} {{ friend.lastname }}
                </p>
              </div>
            </div>

            <div class="buttons">
              <button class="confirm" (click)="friendrequest(friend, $index)">
                <i class="fa-solid fa-user-plus"></i>
              </button>
            </div>
          </div>
          }
        </main>
        }
      </div>
    </div>

    <div class="col-md-5">
      <div class="mt-4">
        @if(accrejRequest?.length > 0){
        <main>
          <div id="header">
            <h1 class="mb-0">Friends Requests</h1>
            <!-- <h2>View All</h2> -->
          </div>

          @for (acceptreject of accrejRequest; track $index) {
          <div id="friends-request" class="mb-2">
            <div class="profiles-pictures">
              <div style="position: relative; display: inline-block;" class="me-3">
                <img class="profile-picture m-0" [src]="acceptreject?.image || '/assets/customer-image/men-shadow.png'"
                  alt="profile picture" />
                @if(acceptreject.online){
                <div class="green_dot"></div>
                }
              </div>
            </div>

            <div class="profile-info">
              <div class="profile-name">
                <h3 class="btn-hover" (click)="profilememberDetails(acceptreject?.username)">
                  {{ acceptreject?.username }}
                </h3>
              </div>
            </div>

            <div class="buttons text-end">
              <button class="confirm accept-btn mx-2 my-1" (click)="acceptrequest(acceptreject, $index)">
                <i class="fa-solid fa-check"></i>
              </button>
              <button class="confirm reject-btn mx-2 my-1" (click)="rejectrequest(acceptreject?.username, $index)">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          }
        </main>
        }
      </div>


      @if(requestSentdata?.length > 0){
      <main class="scrollbar" id="main-box">
        <div id="header">
          <h1 class="mb-0">Sent Reqeust</h1>
        </div>

        <div class="overflow-data">
          @for (sentRequest of requestSentdata; track $index) {
          <div id="friends-request" class="mb-2">
            <div class="profiles-pictures">
              <div style="position: relative; display: inline-block;" class="me-3">
                <img [src]="sentRequest?.image ? sentRequest.image : '/assets/customer-image/men-shadow.png'"
                  class="profile-picture m-0" alt="profile picture" />
                @if(sentRequest.online){
                <div class="green_dot"></div>
                }
              </div>
            </div>

            <div class="profile-info py-1">
              <div class="profile-name">
                <h3 class="btn-hover" (click)="profilememberDetails(sentRequest?.username)">
                  {{ sentRequest?.username }}
                </h3>
              </div>
            </div>

            <div class="buttons">
              <button class="confirm" (click)="cancelrequest(sentRequest, $index)">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          }
        </div>
      </main>
      }
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: removeConfirmFriend }">
  <div class="modal-dialog modal-dialog-centered rounded" role="document">
    <div class="modal-content">
      <div class="modal-body" style="background-color: var(--background-default-color)">
        <h4 class="modal-title text text-center m-0">
          Please comfirm that you want to unfriend
          {{ Removeusername }}
        </h4>

        <div class="modal-footer d-flex justify-content-between">
          <button type="button" (click)="notremoveFriend()" class="text confirm">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <button type="button" (click)="removeFriend()" class="text confirm">
            <i class="fa-solid fa-check"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>